import SectionHeading from "./SectionHeading";
import { channels } from "./data";

export default function Channels() {
  return (
    <section id="channels" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="栏目导览 · 阅读地图"
          title="进入后，你能看到哪些栏目"
          desc="正版官网按编辑部栏目的方式分区组织内容，图文并重。确认认证后，可对照以下栏目快速定位想看的版块。"
          align="center"
        />

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 md:mt-10">
          {channels.map((item) => (
            <article
              key={item.title}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="relative h-44 w-full overflow-hidden md:h-48">
                <img
                  src={item.image}
                  alt={item.title + " 栏目预览图"}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-sm bg-foreground-950/70 px-2 py-0.5 text-[11px] font-medium tracking-wider text-background-100 backdrop-blur">
                  {item.en}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-display text-base font-bold text-foreground-950 md:text-lg">{item.title}</h3>
                  <span className="inline-flex items-center whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-700">
                    {item.count}
                  </span>
                </div>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{item.brief}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}